export const NameErrorMessage = Object.freeze({
  IS_INVALID: "We can't accept that input - please remove numbers, symbols and/or consecutive spaces.",
  IS_EMPTY: 'Please include a response for', // Need to have field name passed at the end of the text
  IS_OVER_LENGTH: 'You have exceeded the maximum amount of characters.',
});

export const DOBErrorMessage = Object.freeze({
  IS_INVALID: "We can't accept that input - please remove letters and symbols",
  IS_EMPTY: 'Please include a response for', // Need to have field name passed at the end of the text
  IS_OVERAGE: 'Age cannot be more than 125 years.',
  IS_OVER_31: 'The dependant is aged 31 or above, please remove the dependant or update the membership composition.',
  IS_UNDERAGE: 'Age must be 18 years or older.',
  IS_FUTURE_DATE: 'Birth date must be today’s date or past date. Please enter today’s date or a past date.',
  IS_ALMOST_31: 'The product selected covers dependants up to 31 years of age. Once they turn 31, they will need to take out their own cover.',
});

export const EmailErrorMessage = Object.freeze({
  IS_INVALID: "That's not an email address. Please enter an email using the base format example@mail.com.",
  IS_EMPTY: 'Please include a response for', // Need to have field name passed at the end of the text
  NOT_MATCH: 'The email addresses do not match. Please re-enter you email address.',
  IS_INTERNAL_EMAIL: 'The email address entered cannot be used for this purpose. Please enter another email address.',
});

export const ContactErrorMessage = Object.freeze({
  IS_INVALID_MOBILE: 'Please enter a phone number using numbers only and in the format 0411 111 222',
  IS_INVALID_OTHERS: 'Please enter a phone number using numbers only and in the format 0411 111 222 or 03 8228 8282.',
  IS_EMPTY: 'Please include a response for', // Need to have field name passed at the end of the text
});

export const ConcessionCardErrorMessage = Object.freeze({
  IS_NUMBER_REQUIRED: 'Please provide a response for Card number.',
  IS_INVALID_NUMBER: 'Please enter 9 numbers and a letter.',
  IS_INVALID_EXPIRY_DATE: 'Please enter the expiry date using the format DD/MM/YYYY.',
  IS_PAST_DATE: 'Please try again, expiry dates must be a future date.',
});

export const FundErrorMessage = Object.freeze({
  IS_INVALID: 'Please enter a combination of up to 19 capital letters and/or numbers.', // Messaging updated in DE2E-583
  IS_REQUIRED: 'Please include a response for Member number.', // carried over from previous implementation, converted to constant
  IS_REQUIRED_YOUR: 'Please include a response for your member number.', // carried over from previous implementation, converted to constant
});

export default { ConcessionCardErrorMessage, ContactErrorMessage, DOBErrorMessage, EmailErrorMessage, NameErrorMessage, FundErrorMessage };
